// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminTalkJs = (client) => ({
    /**
     * `GET /admin/talk-js`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminTalkJsList
     * @source packages/modules/b2c-core/src/api/admin/talk-js/route.ts
     */
    list: (query, headers) => client.fetch("/admin/talk-js", { method: "GET", query, headers }),
});
//# sourceMappingURL=talk-js.js.map